import type { GPaginationProps } from '~/core/gemxql/types';

import { InlineStack, Pagination, Text } from '@shopify/polaris';
import { GPaginationDirection } from '~/core/gemxql/types';

export const DEFAULT_ITEMS_PER_PAGE = 5;

export { GPaginationDirection };
export type { GPaginationProps };

export const GPagination: React.FC<GPaginationProps> = ({
  currentPage,
  totalPages,
  loading,
  handlePageChange,
  ...paginationProps
}) => {
  const hasPrevious = currentPage > 1 && !loading;
  const hasNext = currentPage < totalPages && !loading;

  return (
    <InlineStack gap="500" blockAlign="center">
      <Pagination
        {...paginationProps}
        hasPrevious={!loading && hasPrevious}
        onPrevious={() => handlePageChange(GPaginationDirection.PREVIOUS)}
        hasNext={!loading && hasNext}
        onNext={() => handlePageChange(GPaginationDirection.NEXT)}
      />

      {totalPages > 1 && (
        <Text as="span" variant="bodyMd" numeric>
          {currentPage}/{totalPages}
        </Text>
      )}
    </InlineStack>
  );
};
